import { render } from "./CloseSpecimen.vue?vue&type=template&id=f7bbdd3e"
import script from "./CloseSpecimen.vue?vue&type=script&lang=js"
export * from "./CloseSpecimen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__